<ng-container *ngIf="isEditable; else readonly">
  <form>
    <select [formControl]="retiradaImediataControl" [value]="retiradaImediataControl.value">
      <option [value]="true">SIM</option>
      <option [value]="false">NÃO</option>
    </select>
  </form>
</ng-container>

<ng-template #readonly>
  <span>{{retiradaImediataControl.value? "SIM" : "NÃO" }}</span>
</ng-template>